import { add, differenceInMinutes, differenceInHours, differenceInDays, Duration, startOfDay } from 'date-fns';

export const convertToDuration = (startDate: string) => {
  let mins = differenceInMinutes(new Date(), new Date(startDate));
  let hrs = differenceInHours(new Date(), new Date(startDate));
  let days = differenceInDays(new Date(), new Date(startDate));

  let time = { amount: 0, units: '' };
  if (mins < 60) {
    time.amount = mins;
    time.units = mins === 1 ? 'Minute' : 'Minutes';
  }

  if (mins >= 60 && hrs < 24) {
    time.amount = hrs;
    time.units = hrs === 1 ? 'Hour' : 'Hours';
  }

  if (hrs >= 24) {
    time.amount = days;
    time.units = days === 1 ? 'Day' : 'Days';
  }

  return `${time.amount} ${time.units} ago`;
};

export const periodNextDate = (startDate: Date, period: string): Date | undefined => {
  let dur: Duration;
  switch (period) {
    case 'Daily':
      dur = { days: 1 };
      break;
    case 'Weekly':
      dur = { weeks: 1 };
      break;
    case 'Fortnightly':
      dur = { weeks: 2 };
      break;
    case 'Monthly':
      dur = { months: 1 };
      break;
    case 'Bi-Monthly':
      dur = { months: 2 };
      break;
    case 'Quarterly':
      dur = { months: 3 };
      break;
    case 'Semi-Annual':
      dur = { months: 6 };
      break;
    case '3 Per Annum':
      dur = { months: 4 };
      break;
    case 'Annual':
      dur = { years: 1 };
      break;
    case 'Biennial':
      dur = { years: 2 };
      break;
    case 'Triennial':
      dur = { years: 3 };
      break;
    case '4-yearly':
      dur = { years: 4 };
      break;
    case '5-yearly':
      dur = { years: 5 };
      break;
    default:
      return undefined;
  }
  return add(startDate, dur);
};

export const calculatePeriodDates = (
  startDate: Date,
  endDate: Date,
  period: string,
  includeStartDate?: boolean,
  includeEndDate?: boolean
): Date[] => {
  const periods: Date[] = [];
  if (includeStartDate) periods.push(startDate);
  var date: Date | undefined = periodNextDate(startDate, period);
  while (date && date <= endDate) {
    periods.push(date);
    date = periodNextDate(date, period);
  }
  if (periods.length && includeEndDate && periods[periods.length - 1] < endDate) {
    periods.push(startOfDay(endDate));
  }
  return periods;
};
